import { TasksSkeleton } from '@/widgets/tasks/skeleton'
import { lazy, Suspense } from 'react'
const Tasks = lazy(() => import('@/widgets/tasks'))

export const TasksView = () => {
  return (
    <Suspense fallback={<TasksSkeleton />}>
      <Tasks />
    </Suspense>
  )
}
